import { call, put, takeEvery } from "redux-saga/effects"

import { 
  GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS, 
  GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS, 
  UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS, 
  UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS 
} from "./actionTypes"

import { 
  getCallsDashboardCampaignsStickyColumnsError, 
  getCallsDashboardCampaignsStickyColumnsSuccess, 
  getCallsDashboardStatesStickyColumnsError, 
  getCallsDashboardStatesStickyColumnsSuccess, 
  updateCallsDashboardCampaignsStickyColumnsError, 
  updateCallsDashboardCampaignsStickyColumnsSuccess, 
  updateCallsDashboardStatesStickyColumnsError, 
  updateCallsDashboardStatesStickyColumnsSuccess 
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* onGetCallsDashboardStatesStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_calls_dashboard_states`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCallsDashboardStatesStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getCallsDashboardStatesStickyColumnsError(error))
  }
}

function* onUpdateCallsDashboardStatesStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_calls_dashboard_states/${action?.payload?.user_col_pref_calls_dashboard_state?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateCallsDashboardStatesStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateCallsDashboardStatesStickyColumnsError(error))
  }
}

function* onGetCallsDashboardCampaignsStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_calls_dashboard_campaigns`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCallsDashboardCampaignsStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getCallsDashboardCampaignsStickyColumnsError(error))
  }
}

function* onUpdateCallsDashboardCampaignsStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_calls_dashboard_campaigns/${action?.payload?.user_col_pref_calls_dashboard_campaign?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateCallsDashboardCampaignsStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateCallsDashboardCampaignsStickyColumnsError(error))
  }
}

function* userCallsDashboardColumnPreferenceSaga() {
  yield takeEvery(GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS, onGetCallsDashboardStatesStickyColumns)
  yield takeEvery(UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS, onUpdateCallsDashboardStatesStickyColumns)
  yield takeEvery(GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS, onGetCallsDashboardCampaignsStickyColumns)
  yield takeEvery(UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS, onUpdateCallsDashboardCampaignsStickyColumns)
}

export default userCallsDashboardColumnPreferenceSaga;
